import environment from './environment';

export default function hostingPath(type, path, token) {
  return `https://${type}.${environment.SERVER_NAME}/${path}${
    token ? `${path.includes('?') ? '&' : '?'}token=${token}` : ''
  }`;
}
